/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import ServerSideRender from '@wordpress/server-side-render';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl, ToggleControl, TextControl, FormTokenField, RangeControl } from '@wordpress/components';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

import calendarimage from "./calendar-block.png"

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {

	const { firstDay, defaultView, weekends, id, productIDs, hashtags, defaultTimeFormat, limitEvents, numberOfEvents, defaultDate } = attributes;

	const apiFetch = wp.apiFetch;
	const { addQueryArgs } = wp.url;

	const getProductCategories = (queryArgs) => {
		return apiFetch({
			path: addQueryArgs('wc/store/products/categories', {
				per_page: 0,
				...queryArgs,
			}),
		});
	};

	const productCategories = [];
	getProductCategories().then((categories) => {
		categories.forEach( function( category, index ) {
			productCategories.push( category.slug );
		});	
	});

	const onChangeNumberOfEvents = (val) => {
		setAttributes({ numberOfEvents: val });
	};

	return (
		<>
			<InspectorControls>
				<PanelBody title={__('Calendar Settings', 'woocommerce-events')}>
					<SelectControl
						label={__('Calendar layout', 'woocommerce-events')}
						value={defaultView}
						options={[
							{ label: 'Default', value: '' },
							{ label: 'List view year', value: 'listYear' },
							{ label: 'List view month', value: 'listMonth' },
							{ label: 'List view week', value: 'listWeek' },
							{ label: 'List view day', value: 'listDay' },
						]}
						onChange={(value) =>
							setAttributes({ defaultView: value })
						}
					/>
					<ToggleControl
						label={__('Limit number of events', 'woocommerce-events')}
						checked={limitEvents}
						onChange={() =>
							setAttributes({ limitEvents: !limitEvents })
						}
					/>
					{limitEvents && (
						<RangeControl
							label={__('Number of events', 'woocommerce-events')}
							value={numberOfEvents}
							onChange={onChangeNumberOfEvents}
							min={1}
							max={100}
						/>
					)}
					<SelectControl
						label={__('Calendar start day', 'woocommerce-events')}
						value={firstDay}
						options={[
							{ label: 'Sunday', value: "0" },
							{ label: 'Monday', value: "1" }
						]}
						onChange={(value) =>
							setAttributes({ firstDay: value })
						}
					/>
					<ToggleControl
						label={__('Display weekends', 'woocommerce-events')}
						checked={weekends}
						onChange={() =>
							setAttributes({ weekends: !weekends })
						}
					/>
					<FormTokenField
						label={__('Filter by Category slugs', 'woocommerce-events')}
						value={hashtags}
						suggestions={productCategories}
						onChange={ ( tokens ) => {
							const filteredTokens = [];
							tokens.forEach( function( item, index ) {
								const replacement = item.replace( '#', '' );
								const hashtag = replacement;
								if ( typeof hashtag !== 'undefined' ) {
									filteredTokens.push( hashtag );
								}
							} );
							setAttributes( { hashtags: filteredTokens } );
						} }
					/>
					<FormTokenField
						label={__('Filter by Post or Product IDs', 'woocommerce-events')}
						value={productIDs}
						onChange={ ( tokens ) => {
							const filteredTokens = [];
							tokens.forEach( function( item, index ) {
								const replacement = item.replace( '#', '' );
								const productID = replacement;
								if ( typeof productID !== 'undefined' ) {
									filteredTokens.push( productID );
								}
							} );
							setAttributes( { productIDs: filteredTokens } );
						} }
					/>
					<TextControl
						label="Calendar ID"
						value={id}
						onChange={(value) => setAttributes({ id: value })}
					/>
					<TextControl
						label="Default date"
						placeholder="YYYY-MM-DD"
						value={defaultDate}
						onChange={(value) => setAttributes({ defaultDate: value })}
					/>
					<TextControl
						label="Time format"
						value={defaultTimeFormat}
						onChange={(value) => setAttributes({ defaultTimeFormat: value })}
					/>
				</PanelBody>
			</InspectorControls>
			<div {...useBlockProps()}>
			<img src={calendarimage} alt="FooEvents Calendar Placeholder Image" class="fooevents-calendar-block" />
			</div>
		</>
	);
}
